import { ProxyScrapeError } from '../../core/errors';
import type { HttpClient } from '../../core/http';

/**
 * Stub for the proxy-checker module. Real implementation lands once the
 * v4 /proxy-check endpoints are stable. Public methods listed here are
 * intentional commitments: they will be the surface in v1.x, only their
 * bodies fill in.
 *
 * Until then every call throws so accidental usage is loud, not silent.
 */
export class CheckerClient {
  constructor(protected readonly http: HttpClient) {}

  /** Submit a batch of proxies to be checked against the public judge servers. */
  test(_params: { proxies: string[] }): Promise<never> {
    return Promise.reject(notImplemented('checker.test'));
  }

  /** Quick single-proxy liveness ping. */
  ping(_params: { proxy: string }): Promise<never> {
    return Promise.reject(notImplemented('checker.ping'));
  }
}

function notImplemented(name: string): ProxyScrapeError {
  return new ProxyScrapeError(
    `${name}() is not implemented in this SDK version. The checker module is scaffolded for a future release — track https://github.com/ProxyScrape/proxyscrape-sdk/issues for status.`,
  );
}
